/**
 * Common MUI DataGrid style tokens and sx definitions used across tables in PMS
 * Provides clean custom slim scrollbars, professional header typography,
 * consistent cell alignment, and hover effects.
 */

export const commonDataGridSx = {
  border: "none",
  borderTop: "1px solid #e0e0e0",
  "& .MuiDataGrid-main": {
    overflow: "hidden",
  },
  "& .MuiDataGrid-scrollbar, & .MuiDataGrid-scrollbar--vertical, & .MuiDataGrid-scrollbar--horizontal":
    {
      display: "none !important",
      width: "0 !important",
      height: "0 !important",
      visibility: "hidden !important",
      opacity: 0,
      pointerEvents: "none",
    },
  "& .MuiDataGrid-scrollbarContent": {
    display: "none !important",
  },
  "& .MuiDataGrid-virtualScroller": {
    scrollbarWidth: "thin !important",
    scrollbarColor: "transparent transparent !important",
    transition: "scrollbar-color 0.2s ease-in-out",
  },
  "&:hover .MuiDataGrid-virtualScroller": {
    scrollbarColor: "#cbd5e1 transparent !important",
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
    width: "4px !important",
    height: "4px !important",
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-button": {
    display: "none !important",
    width: "0 !important",
    height: "0 !important",
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-corner": {
    display: "none !important",
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
    backgroundColor: "transparent !important",
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
    backgroundColor: "transparent !important",
    borderRadius: "4px !important",
    transition: "background-color 0.2s ease-in-out",
  },
  "&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
    backgroundColor: "#cbd5e1 !important",
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#94a3b8 !important",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#fff",
    borderBottom: "1px solid #e0e0e0",
    fontSize: "13px",
    fontWeight: 600,
    color: "#6b7280",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 600,
  },
  "& .MuiDataGrid-cell": {
    fontSize: "13px",
    borderBottom: "1px solid #f0f0f0",
    display: "flex",
    alignItems: "center",
    color: "#374151",
  },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
    {
      outline: "none !important",
    },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "#fafafa",
  },
  "& .total-footer-row": {
    backgroundColor: "#fff !important",
    borderTop: "2px solid #e0e0e0 !important",
    fontWeight: "700 !important",
    color: "#1e293b",
    "&:hover": {
      backgroundColor: "#fff !important",
    },
    "& .MuiDataGrid-cell": {
      fontWeight: "700 !important",
      borderBottom: "none",
    },
  },
};

export default commonDataGridSx;
